module.exports = [{"label":"Histórico de VeloeTag","link":"/minha-veloe/:id/identificadores/historico-tag","id":"menuHistorico"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/TemplateDashboard/linksHistoricoTags.json
// module id = 1861
// module chunks = 0